//WW-456[12/15/2022]auth0 - provider -with-history has client ID, domain name details of react Auth0 SDK and redirect URI(URL of application with which the auth0 SDK must interact) - Poornima S

import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { withRouter } from "react-router-dom";

class Auth0ProviderWithHistory extends React.Component {

    onRedirectCallback = (appState) => {
        // Handle the redirect callback after authentication
        this.props.auth.handleRedirectCallback().then(() => {
            // Access appState, which contains the URL the user was redirected from
            console.log('Redirect callback completed', appState);

            // Redirect the user to the URL specified in the returnTo property
            if (appState && appState.returnTo) {
                window.location.href = appState.returnTo;
            }
        });
    };
    render() {
        return (
            <Auth0Provider
                domain="sdi-uat1.us.auth0.com"
                clientId="yn7VJOIyJUNRVyaVSqf7yAxOuYR6zHkV"
                authorizationParams={{
                    redirect_uri: window.location.origin,
                    login_hint: "test@walmart.com"
                }}
                //onRedirectCallback={this.onRedirectCallback}
                useCookiesForTransactions="true"
            >
                {this.props.children}
            </Auth0Provider>
        );
    }
}

export default withRouter(Auth0ProviderWithHistory);





